(function () {
  const handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
  if (!handle) return;

  let availabilityById = null;
  let nameById = null; // "Product Title - Variant Title"

  function getCurrentVariantId() {
    return new URLSearchParams(location.search).get('variant');
  }

  function updateNotifyFormField() {
    if (!nameById) return;
    const vid = getCurrentVariantId();
    if (!vid) return;
    const name = nameById[String(vid)];
    if (!name) return;
    document.querySelectorAll('input[name="contact[product-notification-for]"]').forEach(el => {
      if (el.value !== name) el.value = name;
    });
  }

  // Prefetch product data, then sync once
  fetch(`/products/${handle}.js`, { credentials: 'same-origin' })
    .then(r => r.json())
    .then(product => {
      availabilityById = {};
      nameById = {};
      product.variants.forEach(v => {
        availabilityById[String(v.id)] = v.available;
        nameById[String(v.id)] = v.name;
      });
      updateNotifyFormField();
    })
    .catch(() => {});

  // Watch for variant changes via URL updates (most Shopify themes call
  // history.replaceState on swatch click)
  const origReplaceState = history.replaceState;
  history.replaceState = function () {
    const r = origReplaceState.apply(this, arguments);
    setTimeout(updateNotifyFormField, 0);
    return r;
  };
  const origPushState = history.pushState;
  history.pushState = function () {
    const r = origPushState.apply(this, arguments);
    setTimeout(updateNotifyFormField, 0);
    return r;
  };
  window.addEventListener('popstate', () => setTimeout(updateNotifyFormField, 0));

  // Belt-and-suspenders: also re-check on any variant input change
  document.addEventListener('change', e => {
    if (e.target.matches('input[name="id"], select[name="id"], [name^="options"]')) {
      setTimeout(updateNotifyFormField, 50);
    }
  }, true);

  // Submit guard (existing behavior, unchanged)
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form.matches('form[data-notification-form]')) return;
    if (!availabilityById) return;
    const vid = getCurrentVariantId();
    if (!vid) return;
    if (availabilityById[String(vid)] === true) {
      e.preventDefault();
      e.stopImmediatePropagation();
      console.log('[notify-guard] blocked: variant available', { variantId: vid, defaultPrevented: e.defaultPrevented });
      alert(
        "Good news — this item is actually back in stock!\n\n" +
        "Please refresh the page to add it to your cart."
      );
    }
  }, true);
})();